<div [ngClass]="item.class" class="am-items-container">
    @if (leftItems) {
        <div class="am-items-container__left">
            @for (child of leftItems.children; track trackByProp($index, child)) {
                <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
            }
        </div>
    }
    @if (rightItems) {
        <div class="am-items-container__right">
            @for (child of rightItems.children; track trackByProp($index, child)) {
                <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
            }
        </div>
    }
</div>
